/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Register_As_Company_ButtonInputs */

const en_register_as_company_button = /** @type {(inputs: Register_As_Company_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Register as Company`)
};

const de_register_as_company_button = /** @type {(inputs: Register_As_Company_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als Unternehmen registrieren`)
};

/**
* | output |
* | --- |
* | "Register as Company" |
*
* @param {Register_As_Company_ButtonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const register_as_company_button = /** @type {((inputs?: Register_As_Company_ButtonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Register_As_Company_ButtonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_register_as_company_button(inputs)
	return en_register_as_company_button(inputs)
});